exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "a.MKLbVdVa0qQXnArpLrrd4{padding:20px 0 0 0}\n", ""]);

// Exports
exports.locals = {
	"findFriendsCTA": "MKLbVdVa0qQXnArpLrrd4"
};